// extracted by mini-css-extract-plugin
export var active = "_6p-a";
export var activeIndicator = "_6p-9";
export var disabled = "_6p-b";
export var fullWidth = "_6p-2";
export var lg = "_6p-7";
export var md = "_6p-6";
export var redoButtonTabGroup = "_6p-0";
export var sm = "_6p-5";
export var tabButton = "_6p-4";
export var tabButtonsContainer = "_6p-1";
export var themeDestructive = "_6p-d";
export var themeNormal = "_6p-c";
export var themeSuccess = "_6p-e";
export var xl = "_6p-8";
export var xs = "_6p-3";